export default __webpack_public_path__ + "static/media/utilities.8d17e638.png";